import { useState } from 'react'

import useRedux from '../../../hooks/useRedux'
import useRouter from '../../../hooks/useRouter'
import useTranslations from '../../../hooks/useTranslations'
import {
  childUsers,
  MAX_FILE_SIZE,
  userWiseRole,
} from '../../../utils/constant'
import { include, isEqual, length, notEqual } from '../../../utils/javascript'
import { getItem } from '../../../utils/localstorage'
import { userRelationKey } from '../../userManagement/user.description'
import { deleteImageFileApi, getImageFileApi } from '../jobs.api'

const jobContext = () => {
  const { t } = useTranslations()
  const { location, params } = useRouter()
  const { status } = { ...location.state }
  const {
    consumer,
    site,
    producer,
    recycler,
    transporter,
    refurbisher,
    trader,
    scrappingFacilityManager,
  } = userWiseRole
  const [selectedUsers, setSelectedUsers] = useState({})
  const { selector } = useRedux()
  const userData = selector(state => state.user?.profile_details)
  const { roleId, id: loginUserId, adminId } = { ...userData }
  const parentAdminId = getItem('adminId')
  const [nextBtnLoader, setNextBtnLoader] = useState(false)
  const loginUserData = selector(state => state.user?.profile_details)
  const materialTypeList =
    length(loginUserData?.materialTypes) &&
    loginUserData?.materialTypes?.map(value => value?.materialTypeKey)

  const onUserClear = (id, index = 0) => {
    let newSelectedUsers = {}
    switch (id) {
      case consumer:
        newSelectedUsers = {
          [id]: [],
          [site]: [],
        }
        break

      default:
        newSelectedUsers[id] = []
        break
    }
    setSelectedUsers({ ...selectedUsers, ...newSelectedUsers })
  }

  const onSelfUser = (id, index = 0) => {
    let newSelectedUsers = {}
    newSelectedUsers[id] = [loginUserData]
    setSelectedUsers({ ...selectedUsers, ...newSelectedUsers })
  }

  const onSelectUser = ({ data, roleId, userIndex = 0, apiCall }) => {
    apiCall && apiCall()
    const existingUser = selectedUsers[roleId] || []
    existingUser[userIndex] = data?.[0]
    setSelectedUsers({
      ...selectedUsers,
      [roleId]: existingUser,
    })
  }

  const onFileUploadOrRemove = async ({ file, source = 'USER' }) => {
    if (!file) return
    if (isEqual(file?.file?.status, 'removed')) {
      await deleteImageFileApi({
        params: `?dmsId=${file?.file?.dmsId}`,
      })
      return null
    }
    const isLt5MB = file?.file?.size < MAX_FILE_SIZE
    if (!isLt5MB) return null
    const fileList = file?.fileList || []
    const fileBlob = fileList[length(fileList) - 1]
    if (!fileBlob?.originFileObj) return null
    const formData = new FormData()
    formData.append('file', fileBlob?.originFileObj)
    const resp = await getImageFileApi({
      params: `?source=${source}`,
      payload: formData,
    })
    return resp?.data?.dmsId
  }

  const addNewBuildData = ({ newBuilding }) => {
    setSelectedUsers(prev => ({ ...prev, [site]: [newBuilding] }))
  }

  const getPayloadForUserList = (selectRoleId, extraParams) => {
    if (isEqual(selectRoleId, site)) {
      return { pageSize: 5, consumerId: selectedUsers?.[consumer]?.[0]?.id }
    } else {
      const params = { roleId: selectRoleId }
      if (
        include([...childUsers, scrappingFacilityManager], roleId) &&
        notEqual(consumer, selectRoleId)
      )
        params.userId = adminId
      if (include([consumer, producer], selectRoleId))
        //get list across all MatNext
        params.userId = parentAdminId

      //refactor relationType logic
      if (include([recycler, transporter, refurbisher, trader], selectRoleId))
        params.relationType = userRelationKey.associate

      if (extraParams) {
        Object.assign(params, extraParams)
      }
      return params
    }
  }

  return {
    t,
    roleId,
    status,
    params,
    loginUserId,
    selectedUsers,
    nextBtnLoader,
    materialTypeList,
    setNextBtnLoader,
    onSelfUser,
    onFileUploadOrRemove,
    onUserClear,
    onSelectUser,
    addNewBuildData,
    setSelectedUsers,
    getPayloadForUserList,
  }
}

export default jobContext
